module.exports = __webpack_public_path__ + "media/apps/mitch-ios-3-54c40ae5.png";